import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Stack,
  Divider,
  Box,
  Icon,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import { FiMapPin } from "react-icons/fi";
import axios from "axios";
import { Link as ReactLink } from "react-router-dom";

const PostcodeModal = ({ isOpen, onClose, postcode }) => {
  const [postcodeData, setPostcodeData] = useState([]);
  const [loading, setLoading] = useState(false);

  const gray050800 = mode("gray.50", "gray.800");
  const gray700200 = mode("gray.700", "gray.200");

  useEffect(() => {
    if (!postcode || !isOpen) return;
    setLoading(true);
    axios
      //.get(`https://data.handyapi.com/au-postcodes/${postcode}`)
      .get(`https://data.handyapi.com/au-postcodes/${postcode}`)
      .then((response) => {
        setPostcodeData(response.data.Locations || []);
      })
      .catch((error) => {
        console.error("Error fetching postcode data:", error);
        setPostcodeData([]);
      })
      .finally(() => setLoading(false));
  }, [postcode, isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='md' isCentered>
      <ModalOverlay />
      <ModalContent borderRadius='xl' boxShadow='lg'>
        <ModalHeader fontWeight='bold' fontSize='2xl' textAlign='center' bg={gray050800} borderTopRadius='xl'>
          Postcode Lookup
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <Box textAlign='center'>
              <Text fontSize='md' color={gray700200}>
                Postcode:
              </Text>
              <Text fontWeight='bold' fontSize='xl' color='blue.600'>
                {postcode || "N/A"}
              </Text>
            </Box>
            <Divider />
            {loading ? (
              <Text textAlign='center' color='gray.400'>
                Loading...
              </Text>
            ) : postcodeData.length > 0 ? (
              <Stack spacing={3}>
                {postcodeData.map((data, index) => (
                  <Box
                    key={index}
                    p={3}
                    borderRadius='md'
                    bg={gray050800}
                    //bg='gray.50'
                    boxShadow='sm'
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'
                  >
                    <Box>
                      <Text fontWeight='medium' color={gray700200}>
                        {data.Name || "N/A"}, {data.StateShort || "N/A"}
                      </Text>
                      {/* <Text fontSize='sm' color='gray.500'>
                          #{index + 1}
                        </Text> */}
                    </Box>
                    <Button
                      size='sm'
                      leftIcon={<Icon as={FiMapPin} />}
                      as={ReactLink}
                      to={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        `${data.Name} ${postcode}`
                      )}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      colorScheme='blue'
                      variant='outline'
                    >
                      Map
                    </Button>
                  </Box>
                ))}
              </Stack>
            ) : (
              <Text textAlign='center' color='red.400'>
                No data available for this postcode.
              </Text>
            )}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' onClick={onClose} w='full' borderRadius='md'>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PostcodeModal;
